import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';

type TopImgesPropsType = {
  chatId: number;
  topImageData: any;
};

export const TopImges: React.FC<TopImgesPropsType> = ({
  chatId,
  topImageData,
}) => {
  if (!Array.isArray(topImageData) || topImageData.length === 0) {
    return null;
  }

  return (
    <div className='d-flex flex-row '>
      {topImageData.map((obj: any, index: number) => (
        <div
          className='p-2 bd-highlight '
          key={`${chatId}-${obj?.product_image || index}`}
        >
          <img
            src={
              GET_BASE_URL_IMAGE +
              '/disneyland/images/products_thumbnail/' +
              obj.product_image
            }
            className=' img-fluid'
            alt='img'
            loading='lazy'
            decoding='async'
          />
        </div>
      ))}
    </div>
  );
};
